"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = quickly_convert;
var _isNoData = _interopRequireDefault(require("../is-no-data"));
var _pushAlpha = _interopRequireDefault(require("../push-alpha"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// assuming valid RGB input
function quickly_convert(old_no_data_value, new_no_data_pixel, px) {
  return (0, _isNoData.default)(old_no_data_value, px) ? new_no_data_pixel : (0, _pushAlpha.default)(px);
}